
import AppButton from "../AppButton"
import Article from "../Article"

export default {
  name: "CookieBanner",
  components: {
    AppButton,
    Article
  },
  props: {
    hasManageCookies: {
      type: Boolean,
      default: false
    },
    bannerText: {
      type: Object,
      default: () => {}
    },
    acceptAllButton: {
      type: Object,
      default: () => {}
    },
    manageCookiesButton: {
      type: Object,
      default: () => {}
    }
  }
}
